export type RegistryUrlSnapshot = Record<string, string | string[]>;

export function registryUrlText(snapshot: RegistryUrlSnapshot, key: string): string {
  const value = snapshot[key];
  return Array.isArray(value) ? value[0] || "" : value || "";
}

export function registryUrlSort(
  snapshot: RegistryUrlSnapshot,
  allowed: readonly string[],
  fallback: string,
): string {
  const value = registryUrlText(snapshot, "sort");
  return allowed.includes(value) ? value : fallback;
}
